<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="슥삭" />
            <Navbar></Navbar>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container v-if="userinfo.authAdmin == 2" fluid class="px-5" style="min-height:1200px">
                            <v-row v-if="isUploaded == false">
                                <span class="col-12 mt-5 text-left rem-2">사진 업로드</span>
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">URL은 개인이 따로 보관이 필요합니다.</span>

                                <v-file-input accept="image/*" dense label="File input" class="col-8 col-md-6 mt-2" v-model="file"></v-file-input>
                                <v-btn class="ml-2 mt-2 bg-main-dark text-white" v-on:click="upload()">업로드</v-btn>
                            </v-row>
                            <v-row v-else>
                                <span class="col-12 mt-5 text-left rem-2">사진 업로드 완료</span>
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">URL은 개인이 따로 보관이 필요합니다.</span>

                                <a class="mt-4 col-12 text-left" :href="photoUrl" target="_blank">{{photoUrl}}</a>
                                <a class="mt-4 col-12 text-left" href="/admin/util/photos" target="_self">다른 사진 업로드 하기</a>
                            </v-row>
                        </v-container>

                        <v-container v-else-if="userinfo.authAdmin != 2" fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">권한이 없습니다. 로그인 해주세요.</span>
                            </v-row>
                        </v-container>

                        <v-container v-else fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">로딩중...</span>
                            </v-row>
                        </v-container>

                        <Footer></Footer>
                    </v-flex>
                </v-layout>
            </v-container>

    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 2,

            window: {
                width: 0,
                height: 0
            },
            ismobile: false,
            drawer: false,
            group: null,            

            isUploaded: false,
            photoUrl: '',
            file: null,
        }
    },
    computed:{
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        },
        upload() {
            if (this.file == null) {
                alert('사진을 등록해주세요')
                return
            }
            var fd = new FormData()
            fd.append('imgFile', this.file, 'filename.jpg')

            this.$http.post(`/api/photos/reg`, fd)
            .then((response) => {
                if(response.data.status == 200){
                    console.log(response.data.data);
                    this.photoUrl = response.data.data.photoUrl.original
                    this.isUploaded = true
                    alert('업로드 완료!')
                }
                else{
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            }).catch(error=>{
                console.log(error)
            })
        },
    }
}
</script>

<style lang="css">
</style>


// WEBPACK FOOTER //
// src/pages/PhotoUpload.vue